/**
 * Dialog size constants
 */
export const DIALOG_SIZES = {
  XS: "xs",
  SM: "sm",
  MD: "md",
  LG: "lg",
  XL: "xl"
} as const;

/**
 * Dialog animation durations
 */
export const DIALOG_ANIMATIONS = {
  CONTENT_DELAY: 150,
  ENTER_DURATION: 225,
  EXIT_DURATION: 195
} as const;

/**
 * Default dialog configuration
 */
export const DEFAULT_DIALOG_CONFIG = {
  maxWidth: "sm",
  fullWidth: true,
  dividers: true,
  showCloseIcon: true,
  disableBackdropClick: false,
  disableEscapeKeyDown: false
} as const;
